import { render, staticRenderFns } from "./ResourcesSidebar.vue?vue&type=template&id=7634f16b&scoped=true"
import script from "./ResourcesSidebar.vue?vue&type=script&lang=js"
export * from "./ResourcesSidebar.vue?vue&type=script&lang=js"
import style0 from "./ResourcesSidebar.vue?vue&type=style&index=0&id=7634f16b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7634f16b",
  null
  
)

export default component.exports